import { Component, DoCheck } from '@angular/core';
import { TagComponent } from '../../../design-system/tag/tag.component';
import { ICONS } from '../../../../_helpers/icons.constants';
import { FieldType } from '@ngx-formly/core';
import { TagConfig } from '../../../design-system/tag/tag.modal';

@Component({
    selector: 'formly-tag-input',
    templateUrl: "./formly-tag.component.html",
    standalone: true,
    imports: [TagComponent]
})
export class FormlyTagInputComponent extends FieldType implements DoCheck {

    private lastModelLength: number = -1;
    public tagConfig: TagConfig = { id: '', icon: ICONS.CLOSE, type: 'button', size: 'lg', tags: [], tagColor: 'tag-accent' };

    ngOnInit() {
        this.syncTags();
    }

    ngDoCheck() {
        if (this.getModelArray().length !== this.lastModelLength) {
            this.syncTags();
        }
    }

    private getModelArray(): any[] {
        const val = this.field.model?.[this.field.key as string];
        return Array.isArray(val) ? val : [];
    }

    private syncTags(): void {
        const items = this.getModelArray();
        this.lastModelLength = items.length;
        const idKey = this.field.templateOptions?.idKey ?? 'id';
        const nameKey = this.field.templateOptions?.nameKey ?? 'label';
        const tagColor = this.field.templateOptions?.tagColor ?? 'tag-accent';
        this.tagConfig = {
            ...this.tagConfig,
            tags: items.map(item => ({ id: item[idKey]?.toString(), label: item[nameKey], visible: true, icon: ICONS.CLOSE, tagColor }))
        };
    }

    onTagRemoved(removedId: string): void {
        const idKey = this.field.templateOptions?.idKey ?? 'id';
        const updated = this.getModelArray().filter(item => item[idKey]?.toString() !== removedId);
        this.field.model[this.field.key as string] = updated;
        this.formControl.setValue(updated);
        if (this.field.props?.change) {
            this.field.props.change(this.field, updated);
        }
    }
}